export const limitDecimalPlaces = (
  inputString: string,
  decimalPlaces: number
): { value: number; isValid: boolean } => {
  const value = parseFloat(inputString);
  const fixed = parseFloat(value.toFixed(decimalPlaces));

  const isValid = !Number.isNaN(value) && value >= 0;

  if (isValid) {
    return { value: fixed, isValid };
  }

  return { value: 0, isValid };
};

export const decimalMask = (input: string, decimalPlaces: number = 2): string => {
  let parts = input.split(".");

  if (parts?.length > 2) {
    parts = [parts[0], parts.slice(1).join("")];
  }
  parts[0] = parts[0].replace(/[^0-9]/g, "");
  if (parts.length === 2) {
    parts[1] = parts[1].replace(/[^0-9]/g, "");
    if (parts[1].length > decimalPlaces) {
      parts[1] = parts[1].substring(0, decimalPlaces);
    }
  }

  return parts.join(".");
};
